import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import reportAllAction from '~/modules/master/redux/actions/report-all'

const useReportAll = () => {
  const data = useSelector((state) => get(state, 'master.reportAll'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(reportAllAction, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default useReportAll
